<form  [formGroup]="searchPeleCardTransactionsListForm">
    <div *ngIf="!payMethodID && !collectionBuilderID" class="ibox-content m-b-sm border-bottom">
        <div class="row" style="padding: 10px 15px;">
            <div class="row">
                <mat-accordion>
                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                {{panelOpenState ?  'לחץ לסגירת החיפוש...': 'לחץ להרחבת החיפוש...'}}
                            </mat-panel-title>
                            <mat-panel-description>
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div class="col-sm-12">
                              <mat-form-field>
                                <mat-select apply-enter (selectionChange)="selectionChanged($event)"
                                    placeholder="סטטוס גביה"
                                    [formControl]="searchPeleCardTransactionsListForm.controls.statusResponses"
                                    multiple>
                                    <mat-option *ngFor="let sp of servicesData.StatusResponses" [value]="sp.value">
                                        {{sp.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <div style="text-align:left" class="example-button-row">

                                <button mat-mini-fab color="primary" title="סנן" (click)="getPeleCardTransactions()">
                                    <i class="fa fa-filter"></i></button>
                                &nbsp;&nbsp;<button mat-mini-fab color="primary" title="נקה סינונים"
                                    (click)="clerFilter()"><i class="material-icons">clear</i></button>

                            </div>
                        </div>
                    </mat-expansion-panel>

                </mat-accordion>

            </div>
        </div>
    </div>
    <div class="example-container">
        <div class="bounds">
            <div class="content" style="height: 70%; overflow: auto">
                <mat-table [dataSource]="sourceList" style="width: 100%;" (matSortChange)="sortData($event)"
                    class="example-table" matSort matSortDisableClear matSortDirection="asc">
                    <ng-container matColumnDef="buttons">
                        <mat-header-cell *matHeaderCellDef>...</mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            <button mat-icon-button (click)="openDetails(row);" aria-label="הצג עוד...">
                                <mat-icon style="color: gray;" >remove_red_eye</mat-icon>
                            </button>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="toraxTermID">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-xs> מסוף
                        </mat-header-cell>
                        <mat-cell *matCellDef="let row" data-label="מסוף" fxHide fxShow.gt-xs>
                            {{ row.toraxTermID }} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="pelecardTransactionId">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-xs> מזהה מסוף
                        </mat-header-cell>
                        <mat-cell *matCellDef="let row" data-label="מזהה מסוף" fxHide fxShow.gt-xs>
                            {{ row.pelecardTransactionId }} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="transactionID">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-xs> מזהה
                            מקומי
                        </mat-header-cell>
                        <mat-cell *matCellDef="let row" data-label="מזהה מקומי" fxHide fxShow.gt-xs>
                            {{ row.transactionID }} </mat-cell>
                    </ng-container>



                    <ng-container matColumnDef="debitTotal">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-xs> סכום
                        </mat-header-cell>
                        <mat-cell *matCellDef="let row" data-label="סכום" fxHide fxShow.gt-xs>
                            {{ (row.debitTotal > 0 ? row.debitTotal / 100 : 0) | number  }}  {{(row.debitCurrency == 1 ? 3 : 1) | currency }}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="broadcastDate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-xs> תאריך
                            ושעת שליחה
                        </mat-header-cell>
                        <mat-cell *matCellDef="let row" data-label="תאריך ושעת שליחה" fxHide fxShow.gt-xs>
                            {{ row.broadcastDate}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="debitApproveNumber">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-xs> מס' אישור
                        </mat-header-cell>
                        <mat-cell *matCellDef="let row" data-label="מס' אישור" fxHide fxShow.gt-xs>
                            {{row.debitApproveNumber}} </mat-cell>
                    </ng-container>




                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;">
                    </mat-row>
                </mat-table>
            </div>
        </div>
        <mat-paginator (page)="pageChange($event)" [showFirstLastButtons]="true" [hidePageSize]="false"
            [length]="rowsCount" [pageSize]="pageRows" [pageSizeOptions]="[10, 25, 30, 50, 100]"></mat-paginator>
    </div>
</form>
